import { SharedStyles } from '@opencare/shared-styles';
import { css, styled } from 'styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';

interface SecurityTextWrapperProps {
  $showBackground?: boolean;
}

export const SecurityTextWrapper = styled.div<SecurityTextWrapperProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 8px auto 0;
  width: fit-content;
  border-radius: 16px;
  background: ${({ $showBackground }) => $showBackground ? 'rgba(222, 241, 237, 0.82)' : 'none'};
  padding: ${({ $showBackground }) => $showBackground ? '4px 12px' : '0'};
  
  ${applyStylesForScreenSize([SCREEN_SIZES.PHONE], css`
    background: none;
    padding: 0;
  `)}
`;

export const SecurityText = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  text-align: center;
  ${TYPOGRAPHY.OPEN_SANS.semiBold}
  font-size: 10px;
  line-height: 14px;
  color: ${SharedStyles.COLOR.TEXT.PRIMARY.DEFAULT};

  ${applyStylesForScreenSize([SCREEN_SIZES.PHONE], css`
    ${TYPOGRAPHY.OPEN_SANS.base}
    color: ${SharedStyles.COLOR.TEXT.DEFAULT.PLACEHOLDER};
  `)}
`;

export const CheckIcon = styled.span`
  font-size: 10px;
`;
